// extracted by mini-css-extract-plugin
export default {"root":"TableActions_root__MVz2Z","action":"TableActions_action__A7+FZ","linkAction":"TableActions_linkAction__uHgCJ"};